import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { loadFeatureFlagsAndLimits, loadFeatureFlagsAndLimitsFailure, loadFeatureFlagsAndLimitsSuccess } from './actions';
import { SbkFeatureFlagsAndLimitsDataService } from '../sbk-feature-flags-and-limits.service';

@Injectable()
export class FeatureFlagsAndLimitsEffects {
  private actions$ = inject(Actions);

  loadFeatureFlagsAndLimits$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadFeatureFlagsAndLimits),
      switchMap(() =>
        this.dataService.getFeatureFlagsAndLimits().pipe(
          map((response) => loadFeatureFlagsAndLimitsSuccess(
            {
              features: response.features,
              limits: response.limits,
              downtime: response.downtime
            }
          )),
          catchError((error) => of(loadFeatureFlagsAndLimitsFailure({ error })))
        )
      )
    )
  );

  constructor(
    private dataService: SbkFeatureFlagsAndLimitsDataService
  ) { }
}
